export default __webpack_public_path__ + "static/media/torus-logo.1f8f680f.svg";